import config from '../data/config';

// JT Header
const Header = () => {
  return (
    <div>
      {/* @ts-expect-error Custom element not in JSX namespace*/}
      <jt-navbar redirect={config.REDIRECT_URL} stop-logout="true" />
    </div>
  );
};

export default Header;
